import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function AddBox(props) {
  return (
    <Container
     style={props.style}
     onClick={props.handleClick}
    >
      <Row>
        <Col>
          <div
            className="mb-2"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
              cursor:'pointer'
            }}
          >
            {props.svg}
          </div>
          <p className="mb-2">
           {props.header} <span className='text-decoration-underline pointer' style={{color:"rgba(47, 156, 149, 1)"}}>{props.header2}</span>
          </p>
          <p className="mb-2"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#FBFBFB",
          }}>
            {props.content}
          </p>
        </Col>
      </Row>
    </Container>
  );
}
